import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'
import { OK_FIRST_PART } from 'frontend/constants/callers'
import {
  OK_FIRST_PART_ASSESSMENT_DETAILS_ROUTE_NAME,
  OK_FIRST_PART_BY_CHECKPOINT_DETAILS_ROUTER_NAME,
  OK_FIRST_PART_BY_CHECKPOINT_LIST_ROUTER_NAME,
  OK_FIRST_PART_OVERVIEW_ROUTE_NAME,
  OK_FIRST_PART_ROUTE_NAME,
  OK_FIRST_PART_SCHEDULE_DETAILS_ROUTE_NAME,
  OK_FIRST_PART_SCHEDULE_LIST_ROUTE_NAME,
} from 'frontend/routes/constants'
import { OK_FIRST_PART_CHECK_POINT_FILTERS , OK_FIRST_PART_FILTERS } from 'frontend/constants/filterUrls'
import { OK_FIRST_PART_SOURCE } from 'frontend/constants/okFirstPart'

const HeaderFactoryStructure = () => import('frontend/components/core/HeaderFactoryStructure')
const RemoteFilters = () => import('frontcore/presentation/remote-filters/views/RemoteFilters.vue')
const OkFirstPartOverviewPage = () => import('frontend/pages/okFirstPart/OkFirstPartOverviewPage')
const OkFirstPartScheduleDetails = () => import('frontend/pages/okFirstPart/OkFirstPartScheduleDetails')
const OkFirstPartScheduleList = () => import('frontend/pages/okFirstPart/OkFirstPartScheduleList')
const OkFirstPartPage = () => import('frontend/pages/okFirstPart/OkFirstPartPage')
const OkFirstPartAssessmentDetails = () => import('frontend/pages/okFirstPart/OkFirstPartAssessmentDetails')
const OkFirstPartByCheckpointListPage = () => import('frontend/pages/okFirstPart/OkFirstPartByCheckpointListPage')
const OkFirstPartByCheckpointDetailsPage = () => import('frontend/pages/okFirstPart/OkFirstPartByCheckpointDetailsPage')

export default [
  {
    name: OK_FIRST_PART_ROUTE_NAME,
    path: '/ok-first-part',
    component: OkFirstPartPage,
    redirect: { name: DASHBOARD_MODULE_TOKENS.okFirstPartList.name },
    children: [
      {
        showInMenu: true,
        path: 'overview',
        name: OK_FIRST_PART_OVERVIEW_ROUTE_NAME,
        components: {
          default: OkFirstPartOverviewPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          filters: { filterURL: OK_FIRST_PART_FILTERS },
          header: { caller: OK_FIRST_PART, source: OK_FIRST_PART_SOURCE },
        },
      },
      {
        shownInMenu: true,
        path: 'list',
        name: OK_FIRST_PART_SCHEDULE_LIST_ROUTE_NAME,
        components: {
          default: OkFirstPartScheduleList,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          filters: { filterURL: OK_FIRST_PART_FILTERS },
          default: { source: OK_FIRST_PART_SOURCE },
          header: { caller: OK_FIRST_PART, source: OK_FIRST_PART_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:id',
        name: OK_FIRST_PART_SCHEDULE_DETAILS_ROUTE_NAME,
        components: {
          default: OkFirstPartScheduleDetails,
        },
        props: {
          default: (routerInstance) => {
            return {
              scheduleId: Number(routerInstance.params.id),
              caller: OK_FIRST_PART,
              source: OK_FIRST_PART_SOURCE,
            }
          },
        },
      },
      {
        shownInMenu: false,
        path: 'list/:scheduleId/details/:assessmentId',
        name: OK_FIRST_PART_ASSESSMENT_DETAILS_ROUTE_NAME,
        components: {
          default: OkFirstPartAssessmentDetails,
        },
        props: {
          default: { caller: OK_FIRST_PART, source: OK_FIRST_PART_SOURCE },
        },
      },
      {
        shownInMenu: true,
        path: 'by-checkpoint/list',
        name: OK_FIRST_PART_BY_CHECKPOINT_LIST_ROUTER_NAME,
        components: {
          default: OkFirstPartByCheckpointListPage,
          header: HeaderFactoryStructure,
          filters: RemoteFilters,
        },
        props: {
          filters: { filterURL: OK_FIRST_PART_CHECK_POINT_FILTERS },
          default: { source: OK_FIRST_PART_SOURCE },
          header: { caller: OK_FIRST_PART, source: OK_FIRST_PART_SOURCE },
        },
      },
      {
        shownInMenu: false,
        path: 'by-checkpoint/list/:id',
        name: OK_FIRST_PART_BY_CHECKPOINT_DETAILS_ROUTER_NAME,
        components: {
          default: OkFirstPartByCheckpointDetailsPage,
        },
        props: {
          default: { source: OK_FIRST_PART_SOURCE },
        },
      },
    ],
  },
]
